import React, { useEffect, useState } from "react";
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Paper, Table, TableBody, TableCell, TableHead, TableRow, TextField, Typography } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import ConfirmService from "../../app/components/theme/Confirm/service";
import api from "./api";

const CancellationReasons = () => {
  const [rows, setRows] = useState<any[]>([]);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ id: "", title: "", subtitle: "", emoji: "" });
  const load = () => api.load().then(setRows);
  useEffect(() => { load(); }, []);
  const close = () => { setOpen(false); setForm({ id: "", title: "", subtitle: "", emoji: "" }); };
  const save = () => api.save({ ...form, id: form.id || undefined }).then(() => { close(); load(); });
  const remove = (row: any) => ConfirmService.show("Eliminar", <Typography>¿Deseas eliminar el motivo “{row.title}”?</Typography>, () => api.delete(row.id).then(load));
  return <Paper sx={{ p: 2 }}>
    <Typography sx={{ fontSize: "2rem", fontWeight: "bold", mb: 2 }}>Motivos de cancelación</Typography>
    <Button variant="contained" onClick={() => setOpen(true)} sx={{ mb: 2 }}>Crear motivo</Button>
    <Table><TableHead><TableRow><TableCell /> <TableCell>Emoji</TableCell><TableCell>Título</TableCell><TableCell>Subtítulo</TableCell></TableRow></TableHead>
      <TableBody>{rows.map((row) => <TableRow key={row.id}><TableCell><IconButton color="primary" onClick={() => { setForm({ ...row, emoji: row.emoji || "" }); setOpen(true); }}><EditIcon /></IconButton><IconButton color="error" onClick={() => remove(row)}><DeleteIcon /></IconButton></TableCell><TableCell>{row.emoji}</TableCell><TableCell>{row.title}</TableCell><TableCell>{row.subtitle}</TableCell></TableRow>)}</TableBody>
    </Table>
    <Dialog open={open} onClose={close} fullWidth maxWidth="sm">
      <DialogTitle>{form.id ? "Editar motivo" : "Crear motivo"}</DialogTitle>
      <DialogContent>
        <TextField autoFocus fullWidth margin="normal" label="Emoji" placeholder="Ej. 🔧" inputProps={{ maxLength: 10 }} value={form.emoji} onChange={(e) => setForm({ ...form, emoji: e.target.value })} />
        <TextField fullWidth margin="normal" label="Título" value={form.title} onChange={(e) => setForm({ ...form, title: e.target.value })} />
        <TextField fullWidth margin="normal" label="Subtítulo" value={form.subtitle} onChange={(e) => setForm({ ...form, subtitle: e.target.value })} />

        <Typography sx={{ mt: 2, mb: 1, fontWeight: 600 }}>Vista previa</Typography>
        <Box sx={{
          display: "flex",
          alignItems: "center",
          gap: 1.5,
          minHeight: 64,
          px: 2,
          py: 1,
          border: "1px solid #DCE4EF",
          borderRadius: "12px",
          backgroundColor: "#FFFFFF",
        }}>
          <Box sx={{ width: 24, textAlign: "center", fontSize: 20, lineHeight: 1 }}>
            {form.emoji || "🙂"}
          </Box>
          <Box sx={{ flex: 1, minWidth: 0 }}>
            <Typography sx={{ color: "#202124", fontSize: 14, fontWeight: 700, lineHeight: 1.35 }}>
              {form.title || "Título del motivo"}
            </Typography>
            <Typography sx={{ color: "#718096", fontSize: 12, lineHeight: 1.35, mt: 0.25 }}>
              {form.subtitle || "Subtítulo del motivo"}
            </Typography>
          </Box>
          <Box sx={{ width: 18, height: 18, border: "2px solid #CBD5E1", borderRadius: "50%", flexShrink: 0 }} />
        </Box>
      </DialogContent>
      <DialogActions><Button onClick={close}>Cancelar</Button><Button variant="contained" onClick={save}>Guardar</Button></DialogActions>
    </Dialog>
  </Paper>;
};
export default CancellationReasons;
